export const columnsDataDevelopment = ["ID", "TITLE", "TOPIC", "DESCRIPTION", "ACTIVE", "CREATED AT", "ACTION"];
